(() => {
  if (customElements.get('av-scent-product-details')) return;
  class AromaProductDetails extends HTMLElement {
    connectedCallback() {
      if (this.dataset.enhanced) return;
      this.tabs = [...this.querySelectorAll('[data-av-scent-tab]')];
      this.panels = [...this.querySelectorAll('[data-av-scent-panel]')];
      this.nav = this.querySelector('.av-scent-product-tabs');
      this.nav.setAttribute('role', 'tablist');
      this.tabs.forEach(tab => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', `av-scent-panel-${tab.dataset.avScentTab}`);
        tab.addEventListener('click', event => { event.preventDefault(); this.select(tab.dataset.avScentTab); });
        tab.addEventListener('keydown', event => this.onKey(event, tab));
      });
      this.panels.forEach(panel => panel.setAttribute('role', 'tabpanel'));
      this.dataset.enhanced = 'true';
      this.select('profile');
      this.abort = new AbortController();
      document.addEventListener('click', event => {
        const link = event.target.closest('[data-av-scent-notes-link]');
        if (!link || !this.querySelector('#av-scent-notes')) return;
        event.preventDefault();
        this.showNotes();
      }, {signal: this.abort.signal});
      window.addEventListener('hashchange', () => this.fromHash(), {signal: this.abort.signal});
      this.fromHash();
    }
    disconnectedCallback() { this.abort?.abort(); }
    select(name, focus = false) {
      this.tabs.forEach(tab => {
        const active = tab.dataset.avScentTab === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focus) {
          tab.focus({preventScroll: true});
          const left = tab.offsetLeft - this.nav.offsetLeft - (this.nav.clientWidth - tab.clientWidth) / 2;
          this.nav.scrollTo({left, behavior: 'instant'});
        }
      });
      this.panels.forEach(panel => { panel.hidden = panel.dataset.avScentPanel !== name; });
    }
    onKey(event, tab) {
      let i = this.tabs.indexOf(tab);
      if (event.key === 'ArrowRight') i = (i + 1) % this.tabs.length;
      else if (event.key === 'ArrowLeft') i = (i + this.tabs.length - 1) % this.tabs.length;
      else if (event.key === 'Home') i = 0;
      else if (event.key === 'End') i = this.tabs.length - 1;
      else return;
      event.preventDefault();
      this.select(this.tabs[i].dataset.avScentTab, true);
    }
    showNotes() {
      this.select('profile');
      const notes = this.querySelector('#av-scent-notes');
      if (!notes) return;
      notes.focus({preventScroll: true});
      notes.scrollIntoView({block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
    }
    fromHash() {
      const hash = window.location.hash;
      if (hash === '#av-scent-notes') this.showNotes();
      else {
        const tab = this.tabs.find(item => item.hash === hash);
        if (tab) this.select(tab.dataset.avScentTab);
      }
    }
  }
  customElements.define('av-scent-product-details', AromaProductDetails);
})();

